(function () {
    'use strict';

    var app = angular.module('inoApp');

    app.factory('authService', ['$q', '$rootScope', '$window', 'config', 'storageService', 'userService', authServiceFactory]);

    function authServiceFactory($q, $rootScope, $window, config, storageService, userService) {
        var service = {
            login: login,
            logout: logout
        };

        $rootScope.$on(config.events.auth.notAuthenticated, clearSession);

        return service;

        function login() {
            // Since we're redirecting, trigger a busy event in case the other app is taking its time to respond.
            $rootScope.$broadcast(config.events.appWorkStarted);
            $window.location = config.servicesUrl.identity.signInUrl;
        }

        function logout() {
            var idToken = '';
            if (userService.currentUser.tokens)
                idToken = userService.currentUser.tokens.identityToken;

            clearSession().then(function () {
                $rootScope.$broadcast(config.events.auth.logoutSuccess);
                // Since we're redirecting, trigger a busy event in case the other app is taking its time to respond.
                $rootScope.$broadcast(config.events.appWorkStarted);
                $window.location = config.servicesUrl.identity.signOutUrl + '?idToken=' + encodeURIComponent(idToken);
            });
        }

        function clearSession() {
            return $q.all([storageService.clear()]);
        }
    }
})();